import React from 'react';
import { Layout } from "antd";
import ComingSoon from '../layouts/comingSoon.layout';


const DepartmentsPage : React.FC = () => {
  return (
    <Layout>
        <ComingSoon title="Página do departamento engavetada"/>
    </Layout>
  );
};

export default DepartmentsPage;
